import { c as _c } from "react/compiler-runtime";
import GroupCreateIdentitiesSearch from "./GroupCreateIdentitiesSearch";
import { CommunityMemberMinimal } from "@/entities/IProfile";
import GroupCreateIdentitySelectedItems from "@/components/groups/page/create/config/GroupCreateIdentitySelectedItems";
export default function GroupCreateIdentitiesSelect(t0) {
  const $ = _c(10);
  const {
    onIdentitySelect,
    selectedIdentities,
    selectedWallets,
    onRemove
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="tw-mb-0 tw-text-base sm:tw-text-lg tw-font-semibold tw-text-iron-50">Search Identity</p>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onIdentitySelect || $[2] !== selectedWallets) {
    t2 = <div className="tw-space-y-2 sm:tw-space-y-3">{t1}<GroupCreateIdentitiesSearch onIdentitySelect={onIdentitySelect} selectedWallets={selectedWallets} /></div>;
    $[1] = onIdentitySelect;
    $[2] = selectedWallets;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onRemove || $[5] !== selectedIdentities) {
    t3 = <GroupCreateIdentitySelectedItems selectedIdentities={selectedIdentities} onRemove={onRemove} />;
    $[4] = onRemove;
    $[5] = selectedIdentities;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="tw-p-3 sm:tw-p-5 tw-bg-iron-950 tw-rounded-xl tw-shadow tw-border tw-border-solid tw-border-iron-800"><div className="tw-flex tw-flex-col">{t2}{t3}</div></div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}